import { render, staticRenderFns } from "./formGroup.vue?vue&type=template&id=8381c74a&"
import script from "./formGroup.vue?vue&type=script&lang=js&"
export * from "./formGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports